import React, { Fragment } from 'react';
import { Link, withRouter } from "react-router-dom";
import qfixLogo from '../../styles/img/logo.svg';

import { clearSession,getSession } from "../services/Session";
import { notUndefinedAndNull } from '../utils/Validation';

function Header(props) {

    function onClickLogout(e){
        e.preventDefault()
        let session = getSession()
        let identifier=session.online_admission_configuration.admission_form_for
        clearSession()
        props.history.replace({pathname: `/OnlineAdmissionPortal/${identifier}/onlineFormProcess/login`, state: {}});

    }

    function renderLogout(){
        let session = getSession()
        if(notUndefinedAndNull(session)){
            return(
                <ul className=" f-18 settings color-white">
                    <li>
                        <Link to="#" onClick={onClickLogout}>
                            <span className=" qicon-logout settings-icon icon icon_small"></span>Logout
                        </Link>
                    </li>
                </ul>
            )
        }
    }

    function renderLogo() {
        return (
            <Fragment>
                <div className="col-6">
                    <Link to={{ pathname: "/" ,state:{}}} className="QFix-logo"><img width="100" height="auto" src={qfixLogo} alt="Qfix" /></Link>
                </div>
                <div className="col-6 account-links">
                    {renderLogout()}
                </div>
            </Fragment>
        )
    }

    return (
        <header className="main-navigation payment-header online-form-header">
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    {renderLogo()}
                </div>
            </div>
        </header>
    )    
}


export default withRouter(Header);
